import { render, staticRenderFns } from "./google.vue?vue&type=template&id=7539c910&scoped=true"
import script from "./google.vue?vue&type=script&lang=js"
export * from "./google.vue?vue&type=script&lang=js"
import style0 from "./google.vue?vue&type=style&index=0&id=7539c910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7539c910",
  null
  
)

export default component.exports